import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle"]

  connect() {
    this.updateToggle()
    this.updateTheme()

    // Watch for OS theme preference changes
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
      // Only update theme based on OS preference if user hasn't set a preference
      if (!('theme' in localStorage)) {
        this.updateTheme()
      }
    })
  }

  updateToggle() {
    if (this.hasToggleTarget) {
      this.toggleTarget.checked = this.isDarkMode()
    }
  }

  toggle() {
    if (this.isDarkMode()) {
      localStorage.theme = 'light'
    } else {
      localStorage.theme = 'dark'
    }
    this.updateTheme()
  }

  isDarkMode() {
    return localStorage.theme === 'dark' ||
      (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)
  }

  updateTheme() {
    const darkModeEnabled = this.isDarkMode()
    console.info('isDarkMode', darkModeEnabled)
    
    if (darkModeEnabled) {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
    
    // Update the toggle after theme changes, but not inside isDarkMode check
    // to avoid potential circular logic
    this.updateToggle()
  }
}
